import { object } from "prop-types";
import { observer } from "mobx-react";
import { TimelineSectionSettings, useEstimateEditorSettings, useEstimateTableSettings } from "@tools";
import { ChildActions, TimelineSectionInner, TeamMemberSelect } from "./components";
import { TimelineTeamMemberRemoveButton } from "../TimelineTeamMemberRemoveButton";

export const TimelineTeamMemberRow = observer(({
  teamMember,
  workType,
  section,
  previousTeamMember,
  nextTeamMember,
}) => {
  const { name, color, fontColor } = teamMember;
  const { allowEdition } = useEstimateEditorSettings();
  const { fullSectionActions } = useEstimateTableSettings();

  return (
    <TimelineSectionInner
      name={
        allowEdition
          ? <TeamMemberSelect
            teamMember={teamMember}
            workTypeId={workType.id}
            sectionId={section.id}
            currentlyAddedTeamMembers={workType.currentlyAddedTeamMembers}
          />
          : name
      }
      color={color}
      fontColor={fontColor}
      onColorChange={teamMember.setColor}
      onFontColorChange={teamMember.setFontColor}
      tableDepth={4}
      actions={
        <ChildActions
          teamMember={teamMember}
          workType={workType}
          fullActions={fullSectionActions}
          previousTeamMember={previousTeamMember}
          nextTeamMember={nextTeamMember}
          showActions
        />
      }
    >
      {
        allowEdition &&
        <>
          <TimelineSectionSettings section={section} />
          <TimelineTeamMemberRemoveButton
            teamMemberName={name}
            sectionName={section.name}
            onRemove={teamMember.removeSelf}
          />
        </>
      }
    </TimelineSectionInner>
  );
});

TimelineTeamMemberRow.propTypes = {
  teamMember: object.isRequired,
  workType: object.isRequired,
  section: object.isRequired,
  previousTeamMember: object,
  nextTeamMember: object,
};
